/**
 * AppSync 経由で LLM（Bedrock）を呼び出す
 * 認証は Amplify の Cognito User Pool を使用（既存の AppSync 認証と同じ）
 * 追加のクレデンシャル設定不要
 */
import { API, graphqlOperation } from "aws-amplify";
import { askLlmRequest } from "graphql/queries";

/**
 * OpenAI 形式のメッセージ配列を文字列に変換して AppSync に送る
 * バックエンド側がプロンプト全体を受け取る形式
 *
 * @param {Array<{role: string, content: string}>} messages
 * @returns {Promise<string>}
 */
export const callAppSync = async (messages) => {
  // system + 会話履歴をすべて1つの文字列として渡す
  const fullPrompt = messages
    .map((m) => {
      if (m.role === "system") return `<system>\n${m.content}\n</system>`;
      if (m.role === "user") return `<user>\n${m.content}\n</user>`;
      if (m.role === "assistant")
        return `<assistant>\n${m.content}\n</assistant>`;
      return m.content;
    })
    .join("\n\n");

  console.log(`[callAppSync] fullPrompt length: ${fullPrompt.length} chars`);
  console.log("[callAppSync] fullPrompt:");
  console.log(fullPrompt);

  const result = await API.graphql(
    graphqlOperation(askLlmRequest, { message: fullPrompt })
  );

  const output = result?.data?.AskLlmRequest?.llm_output;
  if (!output) {
    throw new Error("AppSync LLM API からレスポンスが得られませんでした");
  }
  return output;
};
